import { NgxsDataRepository } from '@angular-ru/ngxs/repositories'
import { Computed, DataAction } from '@angular-ru/ngxs/decorators'
import { Route } from '@wm-front/shared/interfaces'
import { map, Observable } from 'rxjs'

export interface SidebarMenuStateModel {
  routeSelected: Route
  routes: Route[]
  menuItems: Route[]
  menuExtended: boolean
}

type SidebarMenuStateType<T> = T & SidebarMenuStateModel

/***/
export class BaseSidebarMenuState<T> extends NgxsDataRepository<
  SidebarMenuStateType<T>
> {
  protected constructor() {
    super()
  }

  /**
   * Returns the routes
   */
  @Computed()
  public get routes(): Route[] {
    return this.snapshot.routes
  }

  /**
   * Returns the selected route
   */
  @Computed()
  public get routeSelected$(): Observable<Route> {
    return this.state$.pipe(map((state) => state.routeSelected))
  }

  /**
   * Returns the menu items
   */
  @Computed()
  public get menuItems(): Route[] {
    return this.snapshot.menuItems
  }

  /**
   * Returns the menu extended
   */
  @Computed()
  public get menuExtended(): boolean {
    return this.snapshot.menuExtended
  }

  /**
   * Toggles the menu
   */
  @DataAction()
  public toggleMenu(): void {
    const state = this.getState()
    this.setState({
      ...state,
      menuExtended: !(state as any).menuExtended,
    })
  }

  /**
   * Extends the menu
   */
  @DataAction()
  public extendMenu(): void {
    const state = this.getState()
    this.setState({
      ...state,
      menuExtended: true,
    })
  }

  /**
   * Closes the menu
   */
  @DataAction()
  public reduceMenu(): void {
    const state = this.getState()
    this.setState({
      ...state,
      menuExtended: false,
    })
  }
}
